import { RichTextContent } from 'ContentfulDefaults/types/_shared';
import { ContentfulBenefitsMedicalFSA } from 'ContentfulDefaults/types/benefitsMedicalFSA';

export const benefitsMedicalFSA: {
  benefits_section_medical_fsa: ContentfulBenefitsMedicalFSA;
} = {
  benefits_section_medical_fsa: {
    standalone_fsa_title: 'Health Care FSA',
    lpfsa_title: 'Health Care Limited Purpose FSA',
    uses_federal_max_body:
      'You can contribute up to the federal limit of {limit} per year to the FSA. If you’re married, your spouse can contribute separately to an account with their employer, also up to the federal limit. ',
    not_federal_max_body:
      'The most you can contribute to the FSA in a year is {limit}. If you’re married, your spouse can contribute separately to an account with their employer, up to the federal limit of {fedLimit}.. ',
    limited_purpose_uses_federal_max_body:
      'You can contribute up to the federal limit of {limit} per year to the limited purpose FSA. If you’re married, your spouse can contribute separately to an account with their employer, also up to the federal limit. ',
    limited_purpose_not_federal_max_body:
      'The most you can contribute to the limited purpose FSA in a year is {limit}. If you’re married, your spouse can contribute separately to an account with their employer, up to the federal limit of {fedLimit}.',
    minimum_contribution_info: 'This account also requires a minimum contribution of {min} per year.',
    has_rollover_body:
      'You can roll over up to {amount} of leftover funds into the next plan year, but anything beyond that, you’ll lose. ',
    no_rollover_body:
      ' The money in this account is “use it or lose it,” meaning you must spend all of the money in the account before the deadline or you lose it. ',
    federal_contribution_limit: 3200,
    contribution_limit_label: 'Contribution limit:',
    eligible_expenses_title: 'Eligible expenses',
    eligible_expenses_intro: 'You can generally spend a health care FSA on things like:',
    eligible_expenses_list: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'doctor visits and prescriptions',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'bandages',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'over-the-counter medications',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'menstrual products',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'contact lens solution, LASIK eye surgery, and prescription eyeglasses',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'pregnancy tests',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'chiropractor visits and acupuncture',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'dental expenses',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '\n',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
          ],
          nodeType: 'unordered-list',
        },
        {
          data: {},
          content: [{ data: {}, marks: [], value: '', nodeType: 'text' }],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    } as RichTextContent,
    eligible_expenses_irs_note: 'For a complete list, see {irsLink}.',
    lpfsa_eligible_expenses_intro:
      'You can generally use a Limited Purpose FSA to cover the cost of dental and vision care, including things like:',
    lpfsa_eligible_expenses_list: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'prescription eyeglasses',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'LASIK eye surgery',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'contact lens solution',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'braces',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '\n',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
          ],
          nodeType: 'unordered-list',
        },
        {
          data: {},
          content: [{ data: {}, marks: [], value: '', nodeType: 'text' }],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    } as RichTextContent,
    important_deadlines_title: 'Important deadlines',
    deadlines_with_rollover:
      'You need to spend all FSA funds but {rolloverAmt} by {incurDate}, or you lose them. You have until {submitDate} to finish filing any claims.',
    deadlines_no_rollover:
      'You need to spend all FSA funds by {incurDate}, or you lose them. You have until {submitDate} to finish filing any claims.',
    lpfsa_deadlines_with_rollover:
      'You need to spend all but {rolloverAmt} by {incurDate}, or you lose them. You have until {submitDate} to finish filing any claims.',
    lpfsa_deadlines_no_rollover:
      'You need to spend all LPFSA funds by {incurDate}, or you lose them. You have until {submitDate} to finish filing any claims.',
  },
};

export default benefitsMedicalFSA;
